/* global Swiper */
const loadEventSliderWithThumbnail = {

	// this is a function that is used dynamically on modal aside-gallery-modal, that´s why we don´t init this function once load the page
	fxInitSliderThumbnail(sliderContainer, sliderContainerThumbnail, initialSlide) {
		// swiper instance of thumbnail
		const swiperThumbnail = new Swiper(sliderContainerThumbnail, {
			initialSlide,
			spaceBetween: 10,
			slidesPerView: 3,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			mousewheel: {
				releaseOnEdges: true
			},

			breakpoints: {
				768: { //tablet up
					slidesPerView: 6
				},
				1024: { //small desktop up
					slidesPerView: 8
				},
				1440: { // desktop up
					slidesPerView: 10
				}
			}
		})

		// swiper instance of main slider
		new Swiper(sliderContainer, {
			initialSlide,
			spaceBetween: 10,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			thumbs: {
				swiper: swiperThumbnail
			},

			on: {
				slideChange: e => {
					setTimeout(() => {
						const captionHeading = e.el.querySelector('.swiper-slide-active').getAttribute('data-figcaption-heading')

						const captionCopy = e.el.querySelector('.swiper-slide-active').getAttribute('data-figcaption-copy')

						document.querySelector('.js-slider-thumbnail-caption-heading').textContent = captionHeading
						document.querySelector('.js-slider-thumbnail-caption-copy').textContent = captionCopy
					}, 1)
				}
			}
		})
	}
}

loadEventSliderWithThumbnail